export const CURRENCY_CODES = {
  TRY: "TRY",
  EUR: "EUR",
  USD: "USD",
  SAR: "SAR",
  GBP: "GBP",
  AZN: "AZN",
  AED: "AED",
  UZS: "UZS",
  RUB: "RUB",
  BYN: "BYN",
  KGS: "KGS",
};

export const CURRENCIES = {
  [CURRENCY_CODES.TRY]: {
    code: "TL",
    label: "Türk Lirası",
    symbol: "TL",
  },

  [CURRENCY_CODES.EUR]: {
    code: CURRENCY_CODES.EUR,
    label: "Euro",
    symbol: "€",
  },
  [CURRENCY_CODES.USD]: {
    code: CURRENCY_CODES.USD,
    label: "US Dollar",
    symbol: "$",
  },
  [CURRENCY_CODES.SAR]: {
    code: CURRENCY_CODES.SAR,
    label: "Saudi Riyal",
    symbol: "SAR",
  },
  [CURRENCY_CODES.GBP]: {
    code: CURRENCY_CODES.GBP,
    label: "British Pound",
    symbol: "£",
  },
  [CURRENCY_CODES.AZN]: {
    code: CURRENCY_CODES.AZN,
    label: "Azerbaijani Manat",
    symbol: "AZN",
  },
  [CURRENCY_CODES.AED]: {
    code: CURRENCY_CODES.AED,
    label: "United Arab Emirates Dirham",
    symbol: "AED",
    // symbol: "د.إ",
  },
  [CURRENCY_CODES.UZS]: {
    code: CURRENCY_CODES.UZS,
    label: "Uzbek Som",
    symbol: "UZS",
  },
  [CURRENCY_CODES.RUB]: {
    code: CURRENCY_CODES.RUB,
    label: "Russian Ruble",
    symbol: "₽",
  },
  [CURRENCY_CODES.BYN]: {
    code: CURRENCY_CODES.BYN,
    label: "Belarusian Ruble",
    symbol: "Br",
  },
  [CURRENCY_CODES.KGS]: {
    code: CURRENCY_CODES.KGS,
    label: "Kyrgyz Som",
    symbol: "KGS",
  },
};

export const DEFAULT_CURRENCY = CURRENCY_CODES.TRY;
